import React, { useRef, useEffect } from 'react';
import { ChatMessage } from './aiChatService';
import { ARGO_API_URL } from '../../config';

interface ChatMessagesProps {
  messages: ChatMessage[];
  isThinking: boolean;
}

export const ChatMessages: React.FC<ChatMessagesProps> = ({ messages, isThinking }) => {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isThinking]);

  return (
    <div className="ai-chat-messages">
      {messages.map((msg, idx) => (
        <div key={idx} className={`ai-chat-bubble ai-chat-bubble--${msg.role}`}>
          <div className="ai-chat-bubble__content">
            {msg.content.split(/(\/?api\/ai\/reports\/[a-f0-9-]+)/g).map((part, i) =>
              part.match(/\/?api\/ai\/reports\/[a-f0-9-]+/) ? (
                <a key={i} href={`${ARGO_API_URL}${part.startsWith('/') ? part : '/' + part}`} target="_blank" rel="noopener noreferrer" style={{ color: '#3D95FD', textDecoration: 'underline' }}>
                  📄 Download Report
                </a>
              ) : (
                <span key={i} style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{part}</span>
              )
            )}
          </div>
          {/* Sources hidden for now — TODO: style as collapsible */}
          {/*msg.sources && msg.sources.length > 0 && (
            <div className="ai-chat-bubble__sources">
              {msg.sources.map((src, i) => (
                <span key={i} className="ai-chat-source-tag">{src}</span>
              ))}
            </div>
          )*/}
          {msg.toolCalls && msg.toolCalls.length > 0 && (
            <div className="ai-chat-bubble__tools">
              <span className="ai-chat-tool-indicator">🔧 Used {msg.toolCalls.length} tool(s)</span>
            </div>
          )}
        </div>
      ))}
      {isThinking && (
        <div className="ai-chat-bubble ai-chat-bubble--assistant ai-chat-bubble--thinking">
          <div className="ai-chat-thinking-dots">
            <span></span><span></span><span></span>
          </div>
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  );
};
